import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'

export default {
    computed: {
        ...mapGetters({
            objectSettingsReceived: 'objectSettings/ObjectSettings',
        }),
    },
    methods: {
        ...mapActions({
            FetchObjectSettings: 'objectSettings/FetchObjectSettings',
            FetchObjectSettingsByObjectTypeID: 'objectSettings/FetchObjectSettingsByObjectTypeID',
        }),
        LoadAllObjectSettings() {
            eventBus.$emit('object-settings-fetch:started');
            this.FetchObjectSettings()
                .then(() => {
                    this.objectSettings = [...this.objectSettingsReceived];
                    eventBus.$emit('object-settings-fetch:success');
                })
                .catch(error => eventBus.$emit('console:error', error))
                .finally(() => eventBus.$emit('object-settings-fetch:finished'));
        },
        LoadObjectSettings(objectType, objectID) {
            eventBus.$emit('object-settings-fetch:started');
            this.FetchObjectSettingsByObjectTypeID({
                ObjectType: objectType,
                ObjectID: objectID
            })
                .then(() => {
                    this.objectSettings = [...this.objectSettingsReceived];
                    eventBus.$emit('object-settings-fetch:success');
                })
                .catch(error => eventBus.$emit('console:error', error))
                .finally(() => eventBus.$emit('object-settings-fetch:finished'));
        },
   },
};